import { render, staticRenderFns } from "./musician.vue?vue&type=template&id=04cca03c"
import script from "./musician.vue?vue&type=script&lang=js"
export * from "./musician.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports